function createElement() {
  const inputElement = document.createElement('input');
  inputElement.style = 'position:absolute;left:-10000px;';
  document.body.appendChild(inputElement);
  return inputElement;
}

/**
 * Copy text to system clipboard 
 * @param {string} text - text to copy
 */
export function copyText(text) {
  // If new API is supported use the new API for copying
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text);
    return;
  }
  // Else use the old and deprecated execComand to copy to clipboard
  const inputElement = createElement();
  inputElement.value = text;
  inputElement.select();
  document.execCommand('copy');
  document.body.removeChild(inputElement);
}

/**
 * Read text from clipboard
 */
export function readText() {
  // If new API is supported use the new API for reading
  if (navigator.clipboard && navigator.clipboard.readText) {
    return navigator.clipboard.readText();
  }
  return Promise.reject('Unsuported Paste action from browser');
}